import React from 'react';
import PropTypes from 'prop-types';
import { Card, Row, Col } from 'react-bootstrap';

const MonitoringStatItem = ({ title, description, className }) => {
  return (
    <Col lg={3} className={className}>
      <p className="fs--1 fw-semi-bold mb-0">
        <span className="text-800 fw-normal">{description}</span>
      </p>
      <h4 className="mb-1 font-sans-serif">
        <span className="fw-normal text-green-600">{title}</span>
      </h4>
    </Col>
  );
};

const MonitoringStats = ({ data }) => {
  function getDescriptionByKey(key) {
    switch (key) {
      case 'assessment_location':
        return 'Project Name';
      case 'assessment_state':
        return 'State';
      case 'assessment_area':
        return 'Project Area';
      case 'assessment_forest':
        return 'Forest Cover';
      default:
        return '';
    }
  }
  return (
    <Card>
      <Card.Body>
        <Row className="g-0">
          {Object.entries(data).map(
            ([key, value], index, array) =>
              key != 'assessment_date' && (
                <MonitoringStatItem
                  key={key}
                  title={value}
                  description={key}
                  // className="border-bottom border-lg-0 border-lg-end py-3 px-lg-3 py-lg-0 flex-grow-1"
                  className={`border-bottom py-3 px-lg-3 py-lg-0 flex-grow-1 border-lg-0 ${
                    index === array.length - 1 ? '' : 'border-lg-end '
                  }`}
                />
              )
          )}
        </Row>
      </Card.Body>
    </Card>
  );
};

MonitoringStatItem.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  className: PropTypes.string
};

MonitoringStats.propTypes = {
  data: PropTypes.object
};

export default MonitoringStats;
